import "./Fusion/Index";
import "./Styles/Animations";

if (process.env.NODE_ENV === "development") {
    console.log("JvMTECH.Components Main.js loaded");
}

setTimeout(() => {
    if (typeof __enable_neos_debug__ === "function") {
        __enable_neos_debug__();
    }
}, 200);
